// Generated by ts-to-zod
import {z} from "zod";

export const mantineDividerPropsSchema = z.strictObject({
	orientation: z
		.union([z.literal("horizontal"), z.literal("vertical")])
		.optional(),
	color: z.string().optional(),
});
